
import Menu from './components/pages/Menu/menu';



function App(){
  return(
    
      <Menu/>
   
  );
}
export default App;